<template>
	<div>
		<j-expendable-box
			v-for="i in numberOfInsureds"
			:key="'Shipping' + i"
			class="mb2"
		>
			<div slot="header" class="xs-12 p4 fs4 fw7 bg5 r2 b1 bc7">
				Shipping {{ i }}
			</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bt0 bc7 r2">
				<case-form :schema="buildSchemaInsured(i - 1)" :isBoxed="false" />
			</div>
		</j-expendable-box>

		<!-- Add Button -->
		<j-button class="mt6" type="primary" @click="numberOfInsureds++"
			>Add</j-button
		>
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
import JButton from "@/components/JButton/"
import JExpendableBox from "@/components/JExpendableBox"

export default {
	name: "SHProposalInsureds",
	components: { CaseForm, JExpendableBox, JButton },

	data() {
		return {
			numberOfInsureds: this.$store?.state?.caseManagement?.case?.insureds
				?.length
				? this.$store.state.caseManagement.case.insureds.length
				: 1
		}
	},

	computed: {
		insureds() {
			return this.$store?.state?.caseManagement?.case?.insureds
		},

		schemaInsureds() {
			let schema = []
			for (let i = 0; i < this.numberOfInsureds; i++) {
				schema.push(...this.buildSchemaInsured(i))
			}
			return schema
		}
	},

	methods: {
		buildSchemaInsured(i) {
			return [
				{
					label: "Select Shipping " + (i + 1),
					component: "entitySelect",
					bindTo: `case.insureds[${i}]`,
					entity: `case.insureds[${i}]`,
					props: {
						allowedEntityTypes: ["object"]
					}
				},
				{
					label: "Shipment Date",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.shipmentDateInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "shipmentDate"
						},
						createOptions: {
							type: "shipmentDate",
							dataType: "date"
						}
					}
				},
				{
					label: "Parcel Description",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.parcelDescriptionInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "parcelDescription"
						},
						createOptions: {
							type: "parcelDescription",
							dataType: "string"
						}
					}
				},
				{
					label: "Invoice Number",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.invoiceNumberInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "invoiceNumber"
						},
						createOptions: {
							type: "invoiceNumber",
							dataType: "string"
						}
					}
				},
				{
					label: "Invoice Amount",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.invoiceAmountInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "invoiceAmount"
						},
						createOptions: {
							type: "invoiceAmount",
							dataType: "number"
						}
					}
				},
				{
					label: "Voyage Origin",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.voyageOriginInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "voyageOrigin"
						},
						createOptions: {
							type: "voyageOrigin",
							dataType: "string"
						}
					}
				},
				{
					label: "Voyage Destination",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.voyageDestinationInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "voyageDestination"
						},
						createOptions: {
							type: "voyageDestination",
							dataType: "string"
						}
					}
				},
				{
					label: "Voyage Via (transshipment)",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.voyageViaInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "voyageVia"
						},
						createOptions: {
							type: "voyageVia",
							dataType: "string"
						}
					}
				},
				{
					label: "Conveyance",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.conveyanceInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "conveyance"
						},
						createOptions: {
							type: "conveyance",
							dataType: "string",
							value: {
								component: "select",
								props: {
									options: [
										{ name: "Air Freight", value: "Air Freight" },
										{ name: "Brinks", value: "Brinks" },
										{ name: "By Contractor", value: "By Contractor" },
										{ name: "DHL", value: "DHL" },
										{ name: "EMS", value: "EMS" },
										{ name: "FERRARI Logistics", value: "FERRARI Logistics" },
										{ name: "Fedex", value: "Fedex" },
										{ name: "G4", value: "G4" },
										{ name: "G4S", value: "G4S" },
										{ name: "Insured Parcel", value: "Insured Parcel" },
										{ name: "Insured Air Parcel", value: "Insured Air Parcel" },
										{ name: "Jewel Express", value: "Jewel Express" },
										{ name: "Malca Amit", value: "Malca Amit" },
										{
											name: "Personal Conveyance",
											value: "Personal Conveyance"
										},
										{ name: "Registered Parcel", value: "Registered Parcel" },
										{
											name: "Registered Air Parcel",
											value: "Registered Air Parcel"
										},
										{ name: "Sea", value: "Sea" },
										{ name: "Sea Freight", value: "Sea Freight" },
										{ name: "Speedpost", value: "Speedpost" },
										{ name: "UPS", value: "UPS" }
									]
								}
							}
						}
					}
				},
				{
					label: "Shipped as",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.shippedAsInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "shippedAs"
						},
						createOptions: {
							type: "shippedAs",
							dataType: "string",
							value: {
								component: "select",
								props: {
									options: [
										{ name: "Non-valuable Cargo", value: "Non-valuable Cargo" },
										{ name: "Valuable Cargo", value: "Valuable Cargo" },
										{ name: "Fragile Cargo", value: "Fragile Cargo" }
									]
								}
							}
						}
					}
				},
				{
					label: "Postal / Airway / Flight No.",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.postalAirwayFlightInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "postalAirwayFlight"
						},
						createOptions: {
							type: "postalAirwayFlight",
							dataType: "string"
						}
					}
				},
				{
					label: "Declared Value for Carriage",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.declaredValueInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "declaredValue"
						},
						createOptions: {
							type: "declaredValue",
							dataType: "number"
						}
					}
				},
				{
					label: "Remark",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.remarkInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "remark"
						},
						createOptions: {
							type: "remark",
							dataType: "string"
						}
					}
				}
			]
		}
	},

	watch: {
		insureds: {
			handler() {
				this.numberOfInsureds = this.$store?.state?.caseManagement?.case
					?.insureds?.length
					? this.$store?.state?.caseManagement?.case?.insureds?.length
					: 1
			}
		}
	}
}
</script>
